import { render, staticRenderFns } from "./LogoPlaceholder.vue?vue&type=template&id=634909df&scoped=true"
import script from "./LogoPlaceholder.vue?vue&type=script&lang=js"
export * from "./LogoPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LogoPlaceholder.vue?vue&type=style&index=0&id=634909df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634909df",
  null
  
)

export default component.exports